import { MenuItemTypes } from "@/types";
import { PERMISSIONS } from "./permission";

export const MENU_ITEMS: MenuItemTypes[] = [
  {
    key: 'user',
    label: 'User management',
    isTitle: false,
    icon: 'fi fi-rr-user',
    url: '/user',
    permission: PERMISSIONS["User Management"],
  },
  {
    key: 'company-management',
    label: 'Company management',
    isTitle: false,
    icon: 'fi fi-rr-building',
    url: '/company-management',
    permission: PERMISSIONS["Company management"]
  }, {
    key: 'employee',
    label: 'Employee management',
    isTitle: false,
    icon: 'fi fi-rr-users-alt',
    url: '/employee-management',
    permission: PERMISSIONS["Employee Management"]
  },  {
    key: 'vendor-management',
    label: 'Vendor management',
    url: '/vendor-management',
    icon: 'fi fi-rr-briefcase',
    isTitle: false,
    permission: PERMISSIONS["Vendor Management"],
  },
  {
    key: 'services',
    label: 'Services',
    url: '/services',
    icon: 'fi fi-rr-layers',
    isTitle: false,
    permission: PERMISSIONS.Services
  },
  {
    key: 'estimated-rates',
    label: 'Estimated rates',
    url: '/estimated-rates',
    icon: 'fi fi-rs-sack-dollar',
    isTitle: false,
    permission: PERMISSIONS["Estimated Rates"]
  },
  {
    key: 'fixed-charges',
    label: 'Fixed charges',
    url: '/fixed-charges',
    icon: 'fi fi-rr-receipt',
    isTitle: false,
    permission: PERMISSIONS["Fixed Charges"]
  },
  {
    key: 'invoice',
    label: 'Invoice',
    url: '/invoice',
    icon: 'fi fi-rr-file-invoice',
    isTitle: false,
    permission: PERMISSIONS.Invoice
  },
  // {
  //   key: 'payments',
  //   label: 'Payments',
  //   url: '/payments',
  //   icon: 'ffi fi-rr-credit-card',
  //   isTitle: false,
  // },
  {
    key: 'report',
    label: 'Report',
    icon: 'fi fi-rr-document',
    permission: PERMISSIONS.Report,
    children: [
    // {
    //   key: 'licence-based-costing',
    //   label: 'Licence based costing',
    //   url: '/report/licence-based-costing',
    //   isTitle: false,
    //   parentKey: 'report',
    // },   {
    //   key: 'companywise-costing',
    //   label: 'Companywise costing',
    //   url: '/report/companywise-costing',
    //   isTitle: false,
    //   parentKey: 'report'
    // }, 
    {
      key: 'license-to-company-report',
      label: 'License to company',
      url: '/license-to-company-report',
      isTitle: false,
      parentKey: 'report',
      permission: PERMISSIONS.Report,
    }, {
      key: 'budget-report',
      label: 'Budget',
      url: '/budget-report',
      isTitle: false,
      parentKey: 'report',
      permission: PERMISSIONS.Report,
    }
  ]
  },
  // {
  //   key: 'system-configuration',
  //   label: 'System Configuration',
  //   isTitle: true,
  // },
  // {
  //   key: 'tax',
  //   label: 'Tax',
  //   url: '/tax',
  //   icon: 'fi fi-rr-percentage',
  //   isTitle: false,
  // },   {
  //   key: 'emai-notification',
  //   label: 'Email notification',
  //   url: '/emai-notification',
  //   icon: 'fi fi-rr-envelope',
  //   isTitle: false,
  // },
  {
    key: 'settings',
    label: 'Settings',
    isTitle: true,
    permission: PERMISSIONS["SMTP Setup"],
  },
  // {
  //   key: 'company-settings',
  //   label: 'Company Settings',
  //   url: '/company-settings',
  //   icon: 'fi fi-rr-settings',
  //   isTitle: false,
  // }, 
  {
    key: 'smtp-setup',
    label: 'SMTP Setup',
    url: '/smtp-setup',
    icon: 'fi fi-rr-database',
    isTitle: false,
    permission: PERMISSIONS["SMTP Setup"]
  },
  {
    key: 'master',
    label: 'Master',
    isTitle: true,
    permission: PERMISSIONS["Service Category"]
  },
  {
    key: 'service-category',
    label: 'Service Category',
    url: '/service-category',
    icon: 'fi fi-rr-tags',
    isTitle: false,
    permission: PERMISSIONS["Service Category"]
  }, {
    key: 'employee-type',
    label: 'Employee type',
    url: '/employee-type',
    icon: 'fi fi-rr-tags',
    isTitle: false,
    permission: PERMISSIONS["Employee Type"]
  },   {
    key: 'licences',
    label: 'Device type',
    url: '/device-type',
    icon: 'fi fi-rr-id-badge',
    isTitle: false,
    permission: PERMISSIONS["Device Type"]
  }, {
    key: 'licences',
    label: 'Licences',
    url: '/licences',
    icon: 'fi fi-rr-id-badge',
    isTitle: false,
    permission: PERMISSIONS.Licences
  }
]

